// extracted by mini-css-extract-plugin
export default {"wrapper":"simpleBreadcrumbs_wrapper__v+hPr"};